import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './Text.css';
import CustomToolbar from './CustomToolbar';
import follow from './images/add-friend.png';
import bell from './images/bell.png';
import share from './images/file.png';
import upload from './images/send.png';
import tools from './images/technical-support.png';
import rec from './images/rec.svg';
import looogo from './images/CompanyLogo.svg';
import {Link} from 'react-router-dom';

const TextEditor = () => {
  const [value, setValue] = useState('');

  const handleChange = (content) => {
    setValue(content);
  };

  const handleUpload = () => {
    console.log('Blog content:', value);
    // Add your API call here to send the content to the server
  };

  const modules = {
    toolbar: {
      container: "#toolbar",
    }
  };

  const formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet',
    'link', 'image', 'video',
    'align', 'color', 'background'
  ];

  return (
    <div className="text-editor-container">
         <Link to="/">
        <img src={looogo} className="loooogo" alt="Logo" />
      </Link>
      
      <div className="editor-header"></div>
      <div className="editor-content">
        {value === '' && (
          <div className="placeholder-text">Title..........
          </div>
        )}
        <CustomToolbar />
        <div className="editor-background">
          <ReactQuill
            value={value}
            onChange={handleChange}
            modules={modules}
            formats={formats}
            // placeholder="Write from here!!!"
          />
        </div>
      </div>
      <div className="custom-buttons">
        <button className="u" onClick={handleUpload}>
          <div className="icon-container">
            <img src={upload} alt="Upload"/>
            <span className="icon-text">Upload</span>
          </div>
        </button>
        <button className="up" onClick={handleUpload}>
          <div className="icon-container">
            <img src={tools} alt="Tools"/>
            <span className="icon-text">Tools</span>
          </div>
        </button>
        <button className="upl" onClick={handleUpload}>
          <div className="icon-container">
            <img src={follow} alt="Followers"/>
            <span className="icon-text">Followers</span>
          </div>
        </button>
        <button className="uplo" onClick={handleUpload}>
          <div className="icon-container">
            <img src={bell} alt="Notification"/>
            <span className="icon-text">Notification</span>
          </div>
        </button>
      </div>
    </div>
  );
};

export default TextEditor;

